// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"CredentialError_modalContainer__2h6Jp","headerText":"CredentialError_headerText__243gR","headerError":"CredentialError_headerError__lFd1j"};